import { Trans } from '~/common/context';
import { useManageBrandTemplates } from '~/connect/api';
import { BaseCustomerBrandsForm } from '~/connect/components';
import { CustomerFormProps } from '~/connect/types';

const BrandsForm = ({ forms, internalCriteria }: CustomerFormProps) => {
  const watchedCriteria = forms.CRITERIA_FORM.methods.watch('criteria');
  const hasSelectedCriteria =
    watchedCriteria.length > 0 &&
    watchedCriteria.every(
      (criterion) => criterion.criterion.id && criterion.value,
    );

  const manageBrandTemplates = useManageBrandTemplates({
    getMatched: {
      enabled: hasSelectedCriteria,
      args: {
        customerCriteria: watchedCriteria.map(({ criterion, value }) => ({
          id: criterion.id,
          valueId: value,
        })),
        customerInternalCriteria: internalCriteria,
      },
    },
  });

  return (
    <BaseCustomerBrandsForm
      isLoading={manageBrandTemplates.getMatched.isFetching}
      brandTemplateLabel={<Trans i18nKey='app.entity.tab.brands' />}
      matchedBrandTemplate={manageBrandTemplates.getMatched.data?.data}
    />
  );
};

export default BrandsForm;
